let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("faq1h")).then(() => parcelRequire('6ozsI'));